import * as React from 'react';
import * as staticPaths from '../../staticPaths';

const ContactForm: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => (
  <div {...props}>
    <form action="https://formspree.io/mogwbrwm" method="POST">
      <div className="shadow sm:rounded-md sm:overflow-hidden border border-gray-300">
        <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
          <div>
            <div className="grid grid-cols-3 gap-6">
              <div className="col-span-3 sm:col-span-2">
                <label
                  htmlFor="exampleInputEmail1"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Email address
                </label>
                <input
                  type="email"
                  name="_replyto"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="you@example.com"
                  className="focus:ring-indigo-500 focus:border-indigo-500 py-2 px-3 flex-1 block w-full rounded-md sm:text-sm border border-gray-300"
                />
              </div>
            </div>
            <p id="emailHelp" className="text-gray-500 mt-2 text-sm">
              Please double-check the address is correct so that we can reply to
              you.
            </p>
          </div>

          <div>
            <label
              htmlFor="exampleFormControlTextarea1"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Message
            </label>
            <textarea
              name="message"
              id="exampleFormControlTextarea1"
              rows={4}
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 py-2 px-3 block w-full sm:text-sm border border-gray-300 rounded-md"
              placeholder=""
              defaultValue={''}
            />
          </div>
        </div>

        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
          <button
            type="submit"
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Send
          </button>
          <p className="text-xs text-gray-500 mt-4">
            Learn how we process contact form data in our{' '}
            <a
              className="underline"
              href={staticPaths.privacy}
              target="_blank"
              rel="noreferrer"
            >
              privacy policy
            </a>
            .
          </p>
        </div>
      </div>
    </form>
  </div>
);

export default ContactForm;
